import React from 'react';
import T from 'prop-types';

import Navbar from '../../components/navbar';

interface SidebarProps {
  children: React.ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ children }) => (
  <>
    <Navbar />
    {children}
  </>
);

Sidebar.propTypes = {
  children: T.node.isRequired,
};

export default Sidebar;
